import React from 'react';
import PropTypes from 'prop-types';
import { Route } from 'react-router-dom';

import './style.scss';

const Tab = (props) => {
	const { passProps = {}, component, children } = props;
	const renderContent = () => {
		if (children) {
			return children;
		}

		const Component = component;
		return <Component {...passProps} />;
	};

	return (
		<Route exact {...props} component={undefined}>
			{renderContent()}
		</Route>
	);
};

Tab.propTypes = {
	path: PropTypes.string.isRequired,
	title: PropTypes.oneOfType([PropTypes.string, PropTypes.func]).isRequired,
	passProps: PropTypes.object,
	component: PropTypes.oneOfType([PropTypes.object, PropTypes.func]),
	children: PropTypes.any
};

export default Tab;
